import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location)
}

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
    },
    {
        path: '/homePage',
        name: 'HomePage',
        component: () => import('../views/homePage.vue'),
    },
    {
        path: '/userInfo',
        name: 'userInfo',
        component: () => import('@/views/userInfo/index.vue'),
        meta: {
            title: '重置密码',
            keepAlive: false
        }
    },
    {
        path: '/myWork',
        name: 'myWork',
        component: () => import('@/views/myWork'),
        meta: {
            title: '我的工作台',
            keepAlive: false
        }
    },
    {
        path: '/client',
        name: 'client',
        component: () => import('@/views/crm/client'),
        meta: {
            title: '客户管理',
            keepAlive: true
        }
    },
    {
        path: '/client/add',
        name: 'clientAdd',
        component: () => import('@/views/crm/client/add.vue'),
        meta: {
            title: '添加客户',
        }
    },
    {
        path: '/client/view',
        name: 'clientView',
        component: () => import('@/views/crm/client/view.vue'),
        meta: {
            title: '客户详情',
        }
    },
    {
        path: '/customer/add',
        name: 'client',
        component: () => import('@/views/crm/customer/add.vue'),
        meta: {
            title: '添加/修改联系人',
        }
    },
    {
        path: '/flowRedirect',
        name: 'flowRedirect',
        component: () => import('@/views/flowRedirect'),
        meta: {
            title: '我的流程',
        }
    },
    {
        path: '/reimbursement',
        name: 'reimbursement',
        component: () => import('@/views/reimbursement'),
        meta: {
            title: '报销',
            groupId: 5
        },
    },
    {
        path: '/remitAccount',
        name: 'remitAccount',
        component: () => import('@/views/remitAccount'),
        meta: {
            title: '划账',
            groupId:31
        },
    },
    {
        path: '/tripReimbursement',
        name: 'tripReimbursement',
        component: () => import('@/views/tripReimbursement'),
        meta: {
            title: '出差报销',
            groupId: 26
        },
    },
    {
        path: '/splitting',
        name: 'splitting',
        component: () => import('@/views/splitting'),
        meta: {
            title: '审核及业绩拆分',
            groupId: 25
        },
    },
    {
        path: '/invoice',
        name: 'invoice',
        component: () => import('@/views/invoice'),
        meta: {
            title: '开票',
            groupId: 7
        },
    },
    {
        path: '/furlough',
        name: 'furlough',
        component: () => import('@/views/furlough'),
        meta: {
            title: '请假',
            groupId: 8
        },
    },
    {
        path: '/seal',
        name: 'seal',
        component: () => import('@/views/seal'),
        meta: {
            title: '用印',
            groupId: 9
        },
    },
    {
        path: '/reservation',
        name: 'reservation',
        component: () => import('@/views/reservation'),
        meta: {
            title: '订餐',
            groupId: 4
        },
    },
    {
        path: '/purchase',
        name: 'purchase',
        component: () => import('@/views/purchase'),
        meta: {
            title: '采购',
            groupId: 6
        },
    },
    {
        path: '/payment',
        name: 'payment',
        component: () => import('@/views/payment'),
        meta: {
            title: '付款',
            groupId: 17
        },
    },
    {
        path: '/departedManagement',
        name: 'departedManagement',
        component: () => import('@/views/departedManagement'),
        meta: {
            title: '离职管理',
            groupId: 10
        },
    },
    {
        path: '/paySheet',
        name: 'paySheet',
        component: () => import('@/views/paySheet'),
        meta: {
            title: '工资条',
        },
    },
    {
        path: '/annualPerformance',
        name: 'annualPerformance',
        component: () => import('@/views/process/view.vue'),
        meta: {
            title: '年度绩效',
            groupId: 21
        },
    },
    {
        path: '/quarterlyPerformance',
        name: 'quarterlyPerformance',
        component: () => import('@/views/process/view.vue'),
        meta: {
            title: '季度绩效',
            groupId: 20
        },
    },
    {
        path: '/wage',
        name: 'wage',
        component: () => import('@/views/process/view.vue'),
        meta: {
            title: '工资',
            groupId: 22
        },
    },
    {
        path: '/cancellation',
        name: 'cancellation',
        component: () => import('@/views/process/view.vue'),
        meta: {
            title: '作废',
            groupId: 33
        },
    },
    {
        path: '/repayment',
        name: 'repayment',
        component: () => import('@/views/process/view.vue'),
        meta: {
            title: '还款',
            groupId: 30
        },
    },
    {
        path: '/refundTicket',
        name: 'refundTicket',
        component: () => import('@/views/refundTicket'),
        meta: {
            title: '退票',
            groupId: 28
        },
    },

    {
        path: '/Salary',
        name: 'Salary',
        component: () => import('@/views/process/view.vue'),
        meta: {
            title: '调薪',
            groupId: 29
        },
    },
    {
        path: '/fundAllocation',
        name: 'fundAllocation',
        component: () => import('@/views/process/view.vue'),
        meta: {
            title: '资金调拨',
            groupId: 27
        },
    },
    {
        path: '/reserveFund',
        name: 'reserveFund',
        component: () => import('@/views/process/view.vue'),
        meta: {
            title: '公积金',
            groupId: 24
        },
    },
    {
        path: '/socialSecurity',
        name: 'socialSecurity',
        component: () => import('@/views/process/view.vue'),
        meta: {
            title: '社保',
            groupId: 23
        },
    },

    {
        path: '/businessTrip',
        name: 'businessTrip',
        component: () => import('@/views/businessTrip'),
        meta: {
            title: '出差',
            groupId: 11
        },
    },
    {
        path: '/visitList',
        name: 'visit',
        component: () => import(/* webpackChunkName: "visit" */ '../views/visitRecords/visit.vue'),
        meta: {
            title: '拜访记录',
            keepAlive: false
        },
    },
    {
        path: '/visitDetails',
        name: 'visitDetails',
        component: () => import(/* webpackChunkName: "visit" */ '../views/visitRecords/visitDetails.vue'),
        meta: {
            title: '拜访记录详情',
            keepAlive: false
        },
    },
    {
        path: '/visitAdd',
        name: 'visitAdd',
        component: () => import(/* webpackChunkName: "visit" */ '../views/visitRecords/visitAdd.vue'),
        meta: {
            title: '新增拜访记录',
            keepAlive: false
        },
    },
    {
        path: '/taskList',
        name: 'task',
        component: () => import(/* webpackChunkName: "task" */ '../views/task/task.vue'),
        meta: {
            title: '我的任务',
            keepAlive: false
        },
    },
    {
        path: '/taskDetails',
        name: 'taskDetails',
        component: () => import(/* webpackChunkName: "taskDetails" */ '../views/task/taskDetails.vue'),
        meta: {
            title: '任务详情',
            keepAlive: false
        },
    },
    {
        path: '/task/wxFileView',
        name: 'wxFileView',
        component: () => import(/* webpackChunkName: "taskDetails" */ '../views/task/wxFileView.vue'),
        meta: {
            title: '企微预览文件',
            keepAlive: false
        },
    },
    {
        path: '/reportPush',
        name: 'reportPush',
        component: () => import('@/views/reportPush'),
        meta: {
            title: '经营数字报告',
        },
    },
    {
        path: '/employeeKanban',
        name: 'employeeKanban',
        component: () => import('@/views/employeeKanban'),
        meta: {
            title: '员工看板',
        },
    },
    {
        path: '/operateKanban',
        name: 'operateKanban',
        component: () => import('@/views/operateKanban'),
        meta: {
            title: '经营可视化看板',
        },
    },
    {
        path: '/feedbackStatistics',
        name: 'feedbackStatistics',
        component: () => import('@/views/feedbackStatistics'),
        meta: {
            title: '反馈统计',
        },
    },
     {
        path: '/feedbackReceivedView',
        name: 'feedbackReceivedView',
        component: () => import('@/views/feedbackStatistics/components/feedbackReceivedView'),
        meta: {
            title: '反馈详情',
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({
        y: 0
    }),
    base: process.env.BASE_URL,
    routes
})

export default router
